import React from 'react';
import { Box, Stack } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import {
  StatusEdit,
  InstallDateEdit,
  WarrantyExpirationEdit,
  ExpectedLifespanEdit,
} from '../fields';

/**
 * StatusDatesSection - Asset status and date fields
 * Contains status, install date, warranty expiration, and expected lifespan
 */
export const StatusDatesSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        icon={<InfoOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Status & Dates"
      />
      <SectionPaper>
        <Stack direction="row" gap={2}>
          <StatusEdit />
          <InstallDateEdit />
          <WarrantyExpirationEdit />
          <ExpectedLifespanEdit />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default StatusDatesSection;
